<script lang="ts">
    import type {Link} from 'typings/portaro.be.types';
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import KpButtonStyleAnchor from '../../ui-widgets/button/KpButtonStyleAnchor.svelte';
    import {resolveTarget} from './utils';
    import {pipe} from 'core/utils';
    import {loc} from '../../utils/pipes';
    import type {ButtonStyle, ComponentSize} from '../../ui-widgets/types';
    import {exists} from 'shared/utils/custom-utils';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let link: Link;
    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let isBlock = false;
    export let additionalClasses = '';
    export let forceNewWindow = false;
    export let icon: UIcons | null = null;

    let target: '_self' | '_blank';
    $: target = forceNewWindow ? '_blank' : resolveTarget(link);
</script>

<KpButtonStyleAnchor href={link.url}
                     {target}
                     rel={target === '_blank' ? 'noreferrer' : null}
                     {buttonSize}
                     {buttonStyle}
                     {isBlock}
                     {additionalClasses}
                     {...$$restProps}>

    {#if exists(icon)}
        <IconedContent {icon}>
            {pipe(link, loc())}
        </IconedContent>
    {:else}
        {pipe(link, loc())}
    {/if}
</KpButtonStyleAnchor>